export type OperadorConciliacao =
  | "IGUAL"
  | "DIFERENTE"
  | "MAIOR_QUE"
  | "MENOR_QUE"
  | "MAIOR_OU_IGUAL"
  | "MENOR_OU_IGUAL"
  | "CONTEM"
  | "PORCENTAGEM"; 

export type FonteConciliacao =
  | "proposta_financeira"
  | "financial_info"
  | "financial_insurance_report"
  | "financial_processor_report"
  | "processor"
  | "simulacao"
  | "produto_contratado"
  | "insurance_info"


export type CondicaoSeguroConciliacao =
  | "QUALQUER"
  | "APENAS_COM_SEGURO"
  | "APENAS_SEM_SEGURO";

export interface RegraConciliacaoReferencia {
  fonte: FonteConciliacao | "";
  campo: string;
  rotulo?: string;
}

export interface RegraConciliacao {
  id?: string;
  descricao?: string;
  obrigatoria?: boolean;
  tolerancia?: number;
  operador: OperadorConciliacao;
  origem: RegraConciliacaoReferencia;
  destino: RegraConciliacaoReferencia;
  condicaoSeguro?: CondicaoSeguroConciliacao;
}

export interface ConfiguracaoConciliacaoConteudo {
  versao: number;
  regras: RegraConciliacao[];
  //condicaoSeguro?: CondicaoSeguroConciliacao;
}

export interface CreateConfiguracaoConciliacaoPayload {
  nome: string;
  ordem: number;
  condicaoSeguro: CondicaoSeguroConciliacao;
  configuracao: ConfiguracaoConciliacaoConteudo;
}

export interface UpdateConfiguracaoConciliacaoPayload {
  nome?: string;
  ordem?: number;
  configuracao?: ConfiguracaoConciliacaoConteudo;
  condicaoSeguro?: CondicaoSeguroConciliacao;
}

export interface ConfiguracaoConciliacao
  extends CreateConfiguracaoConciliacaoPayload {
  id: string;
  createdAt?: string;
  updatedAt?: string;
}

export const FONTES_CONCILIACAO: FonteConciliacao[] = [
  "proposta_financeira",
  "financial_info",
  "financial_insurance_report",
  "financial_processor_report",
  "processor",
  "simulacao",
  "produto_contratado",
  "insurance_info"
];

export const FONTES_LABEL: Record<FonteConciliacao, string> = {
  proposta_financeira: "Proposta Financeira",
  financial_info: "Financial Info",
  financial_insurance_report: "Relatório Financeiro Seguro",
  financial_processor_report: "Relatório Financeiro Processor",
  processor: "Processor",
  simulacao: "Simulação",
  produto_contratado: "Produto Contratado",
  insurance_info: "Informações do Seguro"
};

export const OPERADORES_CONCILIACAO: OperadorConciliacao[] = [
  "IGUAL",
  "DIFERENTE",
  "MAIOR_QUE",
  "MENOR_QUE",
  "MAIOR_OU_IGUAL",
  "MENOR_OU_IGUAL",
  "CONTEM",
  "PORCENTAGEM",
];

export const OPERADORES_LABEL: Record<OperadorConciliacao, string> = {
  IGUAL: "Igual",
  DIFERENTE: "Diferente",
  MAIOR_QUE: "Maior que",
  MENOR_QUE: "Menor que",
  MAIOR_OU_IGUAL: "Maior ou igual",
  MENOR_OU_IGUAL: "Menor ou igual",
  CONTEM: "Contém",
  PORCENTAGEM: "Porcentagem",
};

export const CONDICOES_SEGURO_CONCILIACAO: CondicaoSeguroConciliacao[] = [
  "QUALQUER",
  "APENAS_COM_SEGURO",
  "APENAS_SEM_SEGURO",
];

export const CONDICOES_SEGURO_LABEL: Record<CondicaoSeguroConciliacao, string> = {
  QUALQUER: "Com ou sem seguro",
  APENAS_COM_SEGURO: "Apenas com seguro",
  APENAS_SEM_SEGURO: "Apenas sem seguro",
};